import { useState, useEffect } from 'react';

export default function useDependentState (value, dependencies = []) {
  const [state, setState] = useState(value);
  useEffect(() => {
    setState(value);
  }, dependencies);
  return [state, setState];
};
